module.exports = __webpack_public_path__ + "static/green-dragons-fights-2de3f97bff044b4cb781becd069991b3.jpg";